























































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import groupBuy from "@/store/entities/groupBuy";
import util from "@/lib/util";
import moment from "moment";

@Component({
  components: {},
})
export default class groupBuyDetail extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  @Prop({
    type: Object,
    default: () => {
      return new groupBuy();
    },
  })
  groupBuy: groupBuy;
  type: boolean = false;
  statusList: Array<any> = [
    {
      value: 0,
      label: "待确认价格",
    },
    {
      value: 1,
      label: "取消开团",
    },
    {
      value: 2,
      label: "拼团中",
    },
    {
      value: 3,
      label: "拼团失败",
    },
    {
      value: 4,
      label: "拼团成功",
    },
    {
      value: 5,
      label: "补差价",
    },
  ];

  save() {
    this.$emit("input", false);
  }
  cancel() {
    this.$emit("input", false);
  }
  get createDate() {
    return moment(this.groupBuy.creationTime).format("YYYY-MM-DD HH:mm:ss");
  }
  get getStatus() {
    if (this.groupBuy && this.groupBuy.status >= 0) {
      return this.statusList[this.groupBuy.status].label;
    } else {
      return "";
    }
  }
  get getStartDate() {
    return (
      moment(this.groupBuy.teeDate).format("YYYY-MM-DD") +
      " " +
      util.int2time(this.groupBuy.startTime)
    );
  }
  get getEndDate(){
     return (
      moment(this.groupBuy.endDate).format("YYYY-MM-DD") 
      // +
      // " " +
      // util.int2time(this.groupBuy.endTime)
    );
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}
